import React from 'react';
import { ActionView, ActionEdit, ActionCall, ActionToggle, ActionWhatsapp, ActionAdd } from './LatestTableActions';

/**
 * TableActions Component
 * A reusable, premium action button bar for tables
 * Now acts as a wrapper around the standardized LatestTableActions
 */
export const TableActions = ({
  onView,
  onEdit,
  onCall,
  onToggle,
  onWhatsapp,
  onAdd,
  addTitle = "Add / Start",
  isActive = true,
  disabled = false,
}) => {
  return (
    <div className="flex items-center justify-start gap-2 shrink-0 py-0.5">
      {onAdd && (
        <ActionAdd onClick={() => !disabled && onAdd()} title={addTitle} disabled={disabled} />
      )}

      {onView && (
        <ActionView onClick={() => !disabled && onView()} disabled={disabled} />
      )}

      {onEdit && (
        <ActionEdit onClick={() => !disabled && onEdit()} disabled={disabled} />
      )}

      {onCall && (
        <ActionCall onClick={() => !disabled && onCall()} disabled={disabled} />
      )}

      {onToggle && (
        <ActionToggle onClick={onToggle} isActive={isActive} disabled={disabled} />
      )}

      {onWhatsapp && (
        <ActionWhatsapp onClick={() => !disabled && onWhatsapp()} disabled={disabled} />
      )}
    </div>
  );
};

export default TableActions;




